import { RescheduleFilters, RescheduleItem } from "@myapp/contract";
import { useInfinitePaginated } from "../../../../shared/hooks/useInfinitePaginated";
import { rescheduleKeys } from "../reschedule.keys";
import { rescheduleApi } from "../service";

export function useRescheduleInfiniteQuery(filters: RescheduleFilters) {
  return useInfinitePaginated<RescheduleFilters, RescheduleItem>({
    queryKey: rescheduleKeys.list(filters),
    params: filters,
    fetchFn: ({ page, ...rest }) =>
      rescheduleApi.search({ ...rest, page }).then((response) => response.data),
    retry: false,
  });
}
